import { Column } from "react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { ITableProps } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IProcessJobError } from "src/core/process-job/api/processJobs.api";

export type IProductApprovalImportErrorsColumns = Partial<ITableProps>;

export interface IProductApprovalErrorTable {
  terminology: ITerminology;
}

export const productApprovalImportErrorsTableColumns = (params: IProductApprovalErrorTable): Array<Column<IProcessJobError<"import-file-price">>> => [
  globalTableColumns.id(),
  globalTableColumns.standardText({
    Header: "Line Number",
    accessor: "data.LineNumber",
    width: 100,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Message",
    accessor: "message",
    multiLine: true,
    width: 300
  }),
  globalTableColumns.standardText({
    Header: "Name",
    accessor: "data.Name",
    width: 150,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: params.terminology?.partNumber.singular.text || "Part number",
    accessor: "data.PartNumber",
    width: 150,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Start Date",
    accessor: "data.StartDate",
    width: 100,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "End Date",
    accessor: "data.EndDate",
    width: 100,
    sortable: false,
    filterable: false
  })

];
